import { create } from "zustand";
class Application {
  constructor(env = null, config = {}) {
    this.config = config;
    this.env = env;
  }
  isDevelopment() {
    return this.env === "development";
  }
  isProduction() {
    return this.env === "production";
  }
  isStaging() {
    return this.env === "staging";
  }
  isTest() {
    return this.env === "staging";
  }
  get(key, { allowEmpty = false, defaultValue = void 0 } = {}) {
    var _a;
    const value = (_a = this.config[key]) !== null && _a !== void 0 ? _a : defaultValue;
    if (!allowEmpty && value === void 0) {
      throw new Error(`Config key "${key}" not found`);
    }
    return value;
  }
}
const useApplication = create((set) => ({
  application: new Application(),
  initialize: (env, config) => set({ isInitialized: true, application: new Application(env, config) }),
  isInitialized: false
}));
const useApplicationConfig = (key) => {
  return useApplication((state) => state.application.get(key));
};
const useEnvironment = () => {
  return useApplication((state) => state.application.env);
};
export {
  Application,
  useApplication,
  useApplicationConfig,
  useEnvironment
};
